module.exports = __webpack_public_path__ + "static/img/beans-off.7216599b.png";